import CONST from './Constant';
import CodeFormatterReducer from '../CodeFormatter/Redux/Reducer';
import JwtDecoderReducer from '../JwtDecoder/Redux/Reducer';
import Base64ToImageReducer from '../Base64ToImage/Redux/Reducer';
import BrandColorExtractorReducer from '../BrandColorExtractor/Redux/Reducer';
import ColorBlindnessSimulatorReducer from '../ColorBlindnessSimulator/Redux/Reducer';
import FaviconGeneratorReducer from '../FaviconGenerator/Redux/Reducer';
import ImageStudioReducer from '../ImageStudio/Redux/Reducer';

const INITIAL_STATE = {
    selected: null, // { id, title, description, category, route, available, visibility, version, requiresUrlInput }
};

// Common reducer for all tools
// Store structure: store.tools.codeFormatter, store.tools.jwtDecoder, store.tools.imageFormatConverter, store.tools.selected
const toolsReducer = (state = INITIAL_STATE, action) => {
    // Always call sub-reducers to ensure their state is updated
    const baseState = {
        ...state,
        codeFormatter: CodeFormatterReducer(state.codeFormatter, action),
        jwtDecoder: JwtDecoderReducer(state.jwtDecoder, action),
        base64ToImage: Base64ToImageReducer(state.base64ToImage, action),
        brandColorExtractor: BrandColorExtractorReducer(state.brandColorExtractor, action),
        colorBlindnessSimulator: ColorBlindnessSimulatorReducer(state.colorBlindnessSimulator, action),
        faviconGenerator: FaviconGeneratorReducer(state.faviconGenerator, action),
        imageStudio: ImageStudioReducer(state.imageStudio, action),
    };

    switch (action.type) {
        case CONST.SET_SELECTED:
            // Manipulate payload in reducer: exclude icon as it's a React component and not serializable
            const selectedTool = action.payload ? {
                id: action.payload.id,
                title: action.payload.title,
                description: action.payload.description,
                category: action.payload.category,
                route: action.payload.route,
                available: action.payload.available,
                visibility: action.payload.visibility,
                version: action.payload.version,
                requiresUrlInput: action.payload.requiresUrlInput,
            } : null;
            return {
                ...baseState,
                selected: selectedTool,
            };
        case CONST.CLEAR_SELECTED:
            return {
                ...baseState,
                selected: null,
            };
        default:
            return baseState;
    }
};

export default toolsReducer;

